const CustomInput = ({
  value,
  onChange,
  label,
  disabled = false,
  readOnly = false
}) => {
  return (
    <div>
      <div
        style={{
          fontWeight: "bold",
          fontSize: "16px",
          marginBottom: "5px"
        }}
      >
        {label}
      </div>
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        readOnly={readOnly}
        style={{
          height: "40px",
          padding: "10px",
          fontSize: "16px",
          width: "100%"
        }}
      />
    </div>
  );
};

export default CustomInput;
